import { useEffect } from "react";

export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = `${title} | Suha Builders`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
  return null;
};
